import type { Promisable } from 'type-fest'
import type { TEventName, TEventParams } from './types'

export type TTrackFn = (
  eventName: TEventName,
  eventParams?: TEventParams,
) => Promisable<void>

export abstract class StaticsAnalysis {
  public abstract track: TTrackFn
}
